import { getToken, onMessage } from "firebase/messaging"
import { messaging } from "./firebase"
import notification from "antd/lib/notification"
import strings from "../utils/strings"

export const requestNotificationPermission = async () => {
	try {
		const currentToken = await getToken(messaging, {
			vapidKey: process.env.REACT_APP_VAPID_KEY,
		})
		if (currentToken) {
			return currentToken
		} else {
			console.warn("Não foi possível obter token")
			return null
		}
	} catch (err) {
		console.error("Erro ao obter token:", err)
		return null
	}
}

export const listenToMessages = () => {
	onMessage(messaging, (payload) => {
		const title =
			payload.notification?.title || strings.notifications.newNotificationTitle
		const body =
			payload.notification?.body || strings.notifications.newNotificationBody

		if (Notification.permission === "granted") {
			new Notification(title, { body })
		}

		notification.info({
			message: title,
			description: body,
			placement: "bottomRight",
			duration: 10,
		})
	})
}
